import { useState, useEffect } from "react";

import useApi from "../../hooks/useApiGetPost";

const TYPES = ["Group", "Subgroup", "Category", "Subcategory"];

const INITIAL_DATA = {
  Group: [
    { id: "GRP01", description: "General" },
    { id: "GRP02", description: "Genuine" },
  ],
  Subgroup: [
    { id: "SGP01", description: "Engine Parts" },
  ],
  Category: [
    { id: "CAT01", description: "Fuel System" },
  ],
  Subcategory: [],
};

export default function CommonMasterCreation() {


let companyCode = localStorage.getItem("companyCode") || "-";

  let API_PATHS = localStorage.getItem("apiPaths")
  ? JSON.parse(localStorage.getItem("apiPaths"))
  : "-";
const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

    const {
        loading: loadinggetitemsinMaster,
        data: datagetitemsinMaster,
        get: getitemsinMaster,
      } = useApi();
    
      const {
        loading: loadingpostItemsToMaster,
        data: datapostpostItemsToMaster,
        post: postItemsToMaster,
      } = useApi();
    
  const [activeType, setActiveType] = useState("Group");
  const [data, setData] = useState(INITIAL_DATA);
  const [id, setId] = useState("");
  const [description, setDescription] = useState("");
  const [editIndex, setEditIndex] = useState(null);


  function handleTypeChange(type) {
    setActiveType(type);
    setId("");
    setDescription("");
    setEditIndex(null);
  }

  function handleSave() {
    if (!id.trim() || !description.trim()) return;
    const entry = { id: id.trim(), description: description.trim() };

    let modeToPass = editIndex !== null ? "EDIT" : "ENTRY"
    
   
    let apiUrl = `${BASE_URL}/api/MasterReg/${modeToPass}/${companyCode}/${entry.id}/${entry.description}/${activeType}`;

    postItemsToMaster(apiUrl);
    
  }

  useEffect(() => {
    console.log("datapostpostItemsToMaster", datapostpostItemsToMaster)
    if (datapostpostItemsToMaster) {
      if (datapostpostItemsToMaster?.length == 0) {
       alert("Success")

       setId("");
       setDescription("");
       setEditIndex(null)
       
       getitemsinMaster(
        `${BASE_URL}/api/MasterCount/${companyCode}/${activeType}/-/-`
      );
      } else {
        alert("Failed To Save")
      }
    }
  }, [datapostpostItemsToMaster]);

  function handleEdit(index) {
    setId(datagetitemsinMaster[index]['GRP CODE']);
    setDescription(datagetitemsinMaster[index].DESCRIPTION);
    setEditIndex(index);
  }

  function handleDelete(index) {
    setData({ ...data, [activeType]: datagetitemsinMaster?.filter((_, i) => i !== index) });
    if (editIndex === index) {
      setId("");
      setDescription("");
      setEditIndex(null);
    }
  }

  function handleCancel() {
    setId("");
    setDescription("");
    setEditIndex(null);
  }


  useEffect(()=>{
    getitemsinMaster(
        `${BASE_URL}/api/MasterCount/${companyCode}/${activeType}/-/-`
      );
  },[activeType])


  return (
    <div className="min-h-screen bg-gray-100 font-sans">

      {/* Top bar */}
      <div className=" px-8 py-4">
        <span className="text-black text-base font-semibold tracking-wide">Common Master Creation</span>
      </div>

      <div className="p-8">

        {/* Form */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex flex-wrap gap-4 items-end">

            <div className="flex flex-col gap-1.5">
              <label className="text-xs text-gray-500">Type</label>
              <select
                value={activeType}
                onChange={(e) => handleTypeChange(e.target.value)}
                className="h-10 px-3 border border-gray-300 rounded-md text-sm text-gray-700 bg-white outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-100 w-44"
              >
                {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>

            <div className="flex flex-col gap-1.5 flex-1 min-w-36">
              <label className="text-xs text-gray-500">ID</label>
              <input
                value={id}
                onChange={(e) => setId(e.target.value)}
                placeholder="Enter ID"
                disabled={editIndex !== null}
                className="h-10 px-3 border border-gray-300 rounded-md text-sm text-gray-700 outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-100 w-full"
              />
            </div>

            <div className="flex flex-col gap-1.5 flex-1 min-w-36">
              <label className="text-xs text-gray-500">Description</label>
              <input
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter description"
                className="h-10 px-3 border border-gray-300 rounded-md text-sm text-gray-700 outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-100 w-full"
              />
            </div>

            <div className="flex gap-2">
              <button
                onClick={handleSave}
                className="h-10 px-6 bg-blue-900 hover:bg-blue-800 text-white text-sm font-medium rounded-md transition-colors"
              >
                {editIndex !== null ? "Update" : "Add"}
              </button>
              {editIndex !== null && (
                <button
                  onClick={handleCancel}
                  className="h-10 px-4 bg-gray-100 hover:bg-gray-200 text-gray-600 text-sm rounded-md transition-colors"
                >
                  Cancel
                </button>
              )}
            </div>

          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center">
            <span className="text-sm font-semibold text-blue-900">{activeType} List</span>
            <span className="text-xs text-gray-400">{datagetitemsinMaster?.length} record{datagetitemsinMaster?.length !== 1 ? "s" : ""}</span>
          </div>

          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-100">
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 w-12">#</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 w-1/3">ID</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500">Description</th>
                <th className="px-6 py-3 text-center text-xs font-semibold text-gray-500 w-32">Actions</th>
              </tr>
            </thead>
            <tbody>
              {datagetitemsinMaster?.length === 0 ? (
                <tr>
                  <td colSpan={4} className="px-6 py-12 text-center text-gray-300 text-sm">
                    No entries yet. Add one above.
                  </td>
                </tr>
              ) : (
                datagetitemsinMaster?.map((row, i) => (
                  <tr
                    key={i}
                    className={`border-b border-gray-50 ${editIndex === i ? "bg-blue-50" : i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}`}
                  >
                    <td className="px-6 py-3 text-gray-300 text-xs">{i + 1}</td>
                    <td className="px-6 py-3 font-mono text-xs text-gray-500">{row['GRP CODE']}</td>
                    <td className="px-6 py-3 text-gray-700">{row.DESCRIPTION}</td>
                    <td className="px-6 py-3">
                      <div className="flex items-center justify-center gap-2">
                        <button
                          onClick={() => handleEdit(i)}
                          className="text-xs text-blue-700 border border-blue-200 hover:bg-blue-50 px-3 py-1 rounded transition-colors"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(i)}
                          className="text-xs text-red-500 border border-red-200 hover:bg-red-50 px-3 py-1 rounded transition-colors"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}